import script from "./PhoneLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&setup=true&lang=js"

import "./PhoneLogin.vue?vue&type=style&index=0&id=15c2bb70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c2bb70"]])

export default __exports__